module.exports = __webpack_public_path__ + "media/quienes_somos.495ff21f.mp4";